










































































































import Vue, { PropType } from "vue";
import { ConfirmationOfTheFinishedImageInterface } from "@/model/components/ConfirmationOfTheFinishedImageInterface";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { tel } from "@/model/validators";
import { zenkakuToHankaku } from "@/model/replacer/zenkakuToHankaku.ts";
import { faxShow } from "@/model/views/display.ts";

export default Vue.extend({
  name: "ConfirmationOfTheFinishedImage",

  mixins: [validationMixin],

  props: {
    confirmationOfTheFinishedImage: {
      type: Object as PropType<ConfirmationOfTheFinishedImageInterface>
    }
  },

  validations() {
    let validations = {};
    if (this.isFaxShow) {
      validations = {
        confirmationMethod: { required },
        fax: {
          required,
          tel
        }
      };
    } else {
      validations = {
        confirmationMethod: { required },
        fax: {}
      };
    }

    return validations;
  },

  computed: {
    confirmationMethod(): string {
      return this.confirmationOfTheFinishedImage.confirmationMethod;
    },
    fax(): string {
      return this.confirmationOfTheFinishedImage.fax;
    },
    isFaxShow(): boolean {
      return faxShow(this.confirmationMethod);
    }
  },

  methods: {
    validation(label: string): boolean {
      if (!label) {
        this.$v.$touch();
      } else {
        this.$v[label].$touch();
      }
      return !this.$v.$invalid;
    },
    updateConfirmationOgTheFinishedImage(value: string, label: string): void {
      this.validation(label);
      this.$emit(
        "updateConfirmationOfTheFinishedImage",
        Object.assign({}, this.confirmationOfTheFinishedImage, {
          [label]: value
        })
      );
    },
    openFlowImageModalBtnClick(): void {
      this.$emit("openFlowImageModalBtnClick");
    },
    zenkakuToHankaku
  }
});
